<template>
  <form-builder-editor-field
    :item="item"
    :show-hide-in-form="true"
    :show-hide-in-preview="true"
    :show-hide-in-reports="true"
    :show-required="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <div class="form-group">
      <label :for="item.name + '-label'">Label</label>
      <input :id="item.name + '-label'" class="form-control" type="text"
             v-model="item.label">
    </div>
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorCheckbox.vue?0948772a